/**
 * URL / CMS helpers for manual brand pages (e.g. /manual/sensaphone).
 */

export function slugifyManualSegment(value) {
  return String(value || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9-]/g, "");
}

export function getManualCategorySlug(category) {
  if (!category) return "";
  const url = typeof category.url === "string" ? category.url.trim() : "";
  const fromUrl = url.length > 0 ? url.split("/").filter(Boolean).pop() : "";
  return (
    category.slug ||
    category.manualSlug ||
    fromUrl ||
    slugifyManualSegment(category.name || category.title) ||
    String(category.documentId || category.id || "")
  );
}

export function normalizeManualPathSegment(segment) {
  try {
    return decodeURIComponent(String(segment || "").trim().toLowerCase());
  } catch {
    return String(segment || "").trim().toLowerCase();
  }
}
